const Regular = 'Regular';
const Transfer = 'Transfer';
const Break = 'Break';

export const ShiftSegmentType = Object.freeze({
    [Regular]: 1,
    [Transfer]: 3,
    [Break]: 4,
});

export const ShiftSegmentTypeKeys = Object.freeze({
    1: Regular,
    3: Transfer,
    4: Break
});

export const UKGShiftSegmentTypeName = Object.freeze({
    Regular: "REGULAR_SEGMENT",
    Transfer: "TRANSFER_SEGMENT",
    Break: "BREAK_SEGMENT"
});
